// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__+nPRX","to_back":"Layout_to_back__zjpqj"};